module.exports = __webpack_public_path__ + "img/icone-preambulo.8720ee4c.png";